import { Box, Dialog, Link, Typography } from "@mui/material";
import { useDropzone } from 'react-dropzone';
import { useState } from "react";
import uploadIcon from 'assets/icons/uploadIcon.svg'
import CustomButton from 'components/Common/Button';
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from 'themes/theme';

const sx = {
   dialogStyle:{
       maxHeight: "590px",
       maxWidth:"750px",
       marginTop: 10, 
       borderRadius:"20px",
       },
    uploadBox: {
        height:'250px',
        width:'650px',
        background: '#F2F8FC',
        border:"none", 
        borderRadius:"5px",
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
        }
    } 

const UploadLogo = ({ onClose, open, onSubmit }) => {
    const [file, setFile] = useState(false)
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop: files => setFile(files[0]),
      accept: 'image/*',
    });

    const handleClose = () => {
        onClose();
    };
    const handleSubmit = () => {
        onSubmit(file);
        onClose();
    }
    return (
        <Dialog maxWidth="lg" PaperProps={{ sx: sx.dialogStyle }} onClose={handleClose} open={open}> 
            <Box padding='30px'>
                <Box marginBottom='30px' textAlign='center' color='#25245F' fontSize='24px' fontWeight={600}>
                    Upload Logo
                </Box>
                <Box sx={sx.uploadBox} {...getRootProps()}><input {...getInputProps()} />
                    {
                        isDragActive
                            ? <b>Drop File Here</b>
                            : file
                                ? <strong>{file.name}</strong>
                                : <Box>
                                    <Box fontSize='14px' marginBottom='25px'>
                                        <Link underline="hover">
                                           <Typography component="span" variant="body2B" color="secondary">
                                                 Browse a file
                                           </Typography>{' '}
                                        </Link>or drag and drop</Box>
                                    <Box display='flex' justifyContent='center'>
                                        <Box height='80px' width='80px' sx={{ background: '#fff' }} borderRadius='50%'
                                            alignItems='center' display='flex' justifyContent='center'>
                                             <img src={uploadIcon} alt="Upload Logo" style={{ marginTop: '10px' }}></img>
                                        </Box>
                                    </Box>
                                </Box>
                    }
                </Box>
                <Box display='flex' justifyContent='center' gap='20px' marginTop='35px' marginBottom="10px">
                    <CustomButton sx={{width:"250px"}} onClick={handleClose} type={SECONDARY_BUTTON}>
                        Cancel
                    </CustomButton>
                    <CustomButton sx={{width:"250px"}} onClick={handleSubmit} type={PRIMARY_BUTTON}>
                        Submit
                    </CustomButton>
                </Box>
            </Box>
        </Dialog>
    )
};

export default UploadLogo;